<template>

  <popup
    buttonStyle='success'
    :heading="utilLabel + ' Bill Paymemt'"
    :showText="showText"
    buttonText="Payment"
    :disableButton="! isManager('finance|admin|management')"
    buttonIcon='fa fa-money-bill-alt'
    :disable-save="true"
    @save="onSaveDialog" @close="onCloseDialog">

  <utility-payment ref="upay" :hide-panel="true" :adding="true" :edit-mode="true" :row-data="siteData" />

</popup>

</template>

<script>

import UtilityPayment from '@/components/utility/UtilityLicenseePayment'

export default {

  components: {
    UtilityPayment
  },

  props: {
    siteData: {
      type: Object,
      required: true
    },
    showText: {
      type: Boolean,
      default: true
    },
    tableRef: {
      type: String,
      default: 'utiltable'
    }
  },

  data () {
    return {
      utilLabel: this.getUtilLabel(this.siteData)
    }
  },  // data

  methods: {

    onSaveDialog () {
      this.$refs.upay.onSave()
    },

    onCloseDialog () {
      this.$refs.upay.onClose()
    }
  }
}

</script>
